import type React from 'react';

interface CreditCardIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function CreditCardIcon({ size = 24, ...props }: CreditCardIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.58579 3.08579C1.96086 2.71071 2.46957 2.5 3 2.5H13C13.5304 2.5 14.0391 2.71071 14.4142 3.08579C14.7893 3.46086 15 3.96957 15 4.5V11.5C15 12.0304 14.7893 12.5391 14.4142 12.9142C14.0391 13.2893 13.5304 13.5 13 13.5H3C2.46957 13.5 1.96086 13.2893 1.58579 12.9142C1.21071 12.5391 1 12.0304 1 11.5V4.5C1 3.96957 1.21071 3.46086 1.58579 3.08579ZM2 6.5V11.5C2 11.7652 2.10536 12.0196 2.29289 12.2071C2.48043 12.3946 2.73478 12.5 3 12.5H13C13.2652 12.5 13.5196 12.3946 13.7071 12.2071C13.8946 12.0196 14 11.7652 14 11.5V6.5H2ZM14 5H2V4.5C2 4.23478 2.10536 3.98043 2.29289 3.79289C2.48043 3.60536 2.73478 3.5 3 3.5H13C13.2652 3.5 13.5196 3.60536 13.7071 3.79289C13.8946 3.98043 14 4.23478 14 4.5V5ZM3 9.5C3 9.22386 3.22386 9 3.5 9H7.5C7.77614 9 8 9.22386 8 9.5C8 9.77614 7.77614 10 7.5 10H3.5C3.22386 10 3 9.77614 3 9.5ZM3 11C3 10.7239 3.22386 10.5 3.5 10.5H5.5C5.77614 10.5 6 10.7239 6 11C6 11.2761 5.77614 11.5 5.5 11.5H3.5C3.22386 11.5 3 11.2761 3 11Z"
        fill="currentColor"
      />
    </svg>
  );
}
